import './assets/scss/customizer.scss';
import './assets/scss/socialv.scss';

function App(props) {
  return <div className="App">{props.children}</div>;
}

export default App;
